// SPDX-License-Identifier: AGPL-3.0-or-later
// KONVO: open Settings → Assistant at the Suggestions section (the pop-up menu's "Suggestion settings").

import * as ModalCommands from '@app/features/ui/commands/ModalCommands';
import {UserSettingsModal} from '@app/features/user/components/modals/UserSettingsModal';

export const CORNER_SETTINGS_SECTION_ID = 'konvo-assistant-suggestions';

/** Scroll the section into view once the tab has rendered it (tries for about two seconds). */
function scrollToSuggestions(tries = 40): void {
	const section = document.getElementById(CORNER_SETTINGS_SECTION_ID);
	if (section) {
		section.scrollIntoView({block: 'start'});
		return;
	}
	if (tries > 0) window.setTimeout(() => scrollToSuggestions(tries - 1), 50);
}

export function openCornerSettings(): void {
	ModalCommands.push(ModalCommands.modal(() => <UserSettingsModal initialTab="konvo_assistant" />));
	window.setTimeout(() => scrollToSuggestions(), 50);
}
